import { createStore, applyMiddleware } from "redux";
import reducers from "reducers";
import thunk from "redux-thunk";
import { logger } from "redux-logger";
const logs = [];
if (process.env.NODE_ENV === "development") {
  logs.push(logger);
}
const store = createStore(reducers, applyMiddleware(...logs, thunk));

export default store;
